import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@fontsource-variable/outfit";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import "./styles.css";
import { installTopzleWebMcp } from "./webMcp";

try {
  window.sessionStorage.removeItem("topzle.asset-recovery.v1");
} catch {
  // Private browsing can block session storage.
}
const recoveredUrl = new URL(window.location.href);
if (recoveredUrl.searchParams.has("_topzle_refresh")) {
  recoveredUrl.searchParams.delete("_topzle_refresh");
  window.history.replaceState(window.history.state, "", recoveredUrl.toString());
}

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1 } },
});
const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Topzle root element is missing");
installTopzleWebMcp();
if (window.location.hostname === "www.topzle.com") {
  window.location.replace(
    `https://topzle.com${window.location.pathname}${window.location.search}${window.location.hash}`,
  );
} else {
  createRoot(rootElement).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </StrictMode>,
  );
}
